import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { BrowserService } from '../../services/browser.service';
import { GalleryService } from '../../services/gallery.service';
import { JsonLDService } from '../../services/json-ld.service';
import { PublicTenantService } from '../../services/public-tenant.service';
import { getTenantJsonLdOrg } from '../libs/get-tenant-json-ld-org';
import { getTenantFromSnapshot } from './tenant-public.guard';

@Injectable({
  providedIn: 'root',
})
export class TenantJsonLdGuard {
  private publicTenantService = inject(PublicTenantService);
  private browserService = inject(BrowserService);
  private galleryService = inject(GalleryService);
  private jsonLdService = inject(JsonLDService);

  async canActivate(next: ActivatedRouteSnapshot): Promise<true> {
    try {
      const tenant = await getTenantFromSnapshot(
        next,
        this.publicTenantService,
        this.browserService,
        this.galleryService
      );
      if (tenant) {
        this.jsonLdService.add('page', {
          '@context': 'https://schema.org',
          '@type': 'ProfilePage',
          mainEntity: getTenantJsonLdOrg(tenant),
        });
      }
    } catch {}

    return true;
  }
}
